import { Button } from '../../../components/ui/Button'
import { EmptyState } from '../../../components/ui/EmptyState'
import type { WorkspaceRedactedStub } from '../types'

export interface NotAMemberOverlayProps {
  readonly workspace: WorkspaceRedactedStub
  readonly onRequestAccess: () => Promise<void>
  readonly busy: boolean
}

/**
 * The not-a-member overlay (screens.md §8: "Empty-state overlay (not-a-
 * member): 'This workspace is private... Request access'"). Renders ONLY
 * the five fields `WorkspaceRedactedStub` carries (`id`/`visibility`/
 * `access`/`canRequestAccess`/`myJoinRequestStatus`) — per the security
 * ruling (UID-48a-app 7e6ff4d), the reduced stub has NO `name` at all, so
 * the copy is deliberately generic ("this private workspace," never the
 * workspace's name) rather than assuming or fetching withheld content. The
 * server is the authority on what's redacted; this component is
 * presentation-only.
 */
export function NotAMemberOverlay({ workspace, onRequestAccess, busy }: NotAMemberOverlayProps) {
  if (workspace.myJoinRequestStatus === 'pending') {
    return (
      <EmptyState
        title="This project is private"
        detail="Your request to join is pending review."
      />
    )
  }

  return (
    <EmptyState
      title="Request access to this private project"
      detail="You need to be a member to see its contents."
      action={
        workspace.canRequestAccess ? (
          <Button onClick={onRequestAccess} loading={busy}>
            Request access
          </Button>
        ) : undefined
      }
    />
  )
}
